import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconFlagRu = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 512 512" size={size}>
      <g>
        <rect fill="#F4F4F4" height="99.6" width="512" y="106.7" />
        <rect fill="#324095" height="99.6" width="512" y="206.2" />
        <rect fill="#D81F26" height="99.6" width="512" y="305.8" />
      </g>
    </BaseIcon>
  );
}

export default IconFlagRu;